import React from "react";

import { Skeleton, TableCell, TableRow } from "@mui/material";

const SKELETON_ROW_COUNT = 5;
const COLUMN_COUNT = 5;

export const UserFieldsLoader = () => {
  return (
    <>
      {Array.from({ length: SKELETON_ROW_COUNT }).map((_, rowIndex) => (
        <TableRow
          // eslint-disable-next-line react/no-array-index-key
          key={rowIndex}
          data-testid="user-field-table-loader-row"
        >
          {Array.from({ length: COLUMN_COUNT }).map((__, cellIndex) => (
            // eslint-disable-next-line react/no-array-index-key
            <TableCell key={cellIndex} align="left">
              <Skeleton variant="text" height="24px" />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
};
